/*
 * Model for a scheduled status.
 * Right now, it's a model since we can only have one scheduled status at a time.
 * Perhaps a collection will be added in the future?
 */

define(["backbone", "moment", "messaging/messenger"], function (Backbone, Moment, Messenger) {
  var TopicScheduledStatusModel = {};

  TopicScheduledStatusModel.topicScheduledStatus = Backbone.Model.extend({
    idAttribute: "statusId",
    defaults: {
      statusId: 0,
      statusTimestamp: null,
      responseTemplateIds: null,
    },
    parse: function (response) {
      if (response) {
        response.statusTimestamp = Messenger.reqres.request("to:date", response.statusTimestamp);
      }
      return response;
    },
    reset: function () {
      //I tried saving the time options, but I couldn't re-set them after a save
      //for an unknown reason - the code would not hit, even with a cleared cache,
      //verifying that Firefox saw the code, debugging in NetBeans and Firefox, etc.
      //So I'll re-build it instead
      //var timeOptions = this.get("timeOptions");

      //re-create the time options
      //initialize the time dropdown to be properly i18n'ed
      //loop through the minutes of the day in timeIncrement minute increments
      var timeIncrement = 60;
      var timeOptions = [];
      var minutesPerDay = 1440;
      var midnight = Moment({ minute: 0 });
      for (var minutes = 0; minutes < minutesPerDay; minutes += timeIncrement) {
        var time = Moment({ minute: 0 }).add("minutes", minutes);
        var timeDisplay = Messenger.reqres.request("get:formatted:time", time);
        //time value is the millisecond offset from midnight to the timeString
        timeOptions.push({
          timeValue: time.valueOf() - midnight.valueOf(),
          timeString: timeDisplay,
        });
      }
      //clear everything
      this.clear({ silent: true }); //clear all attributes
      //set the time options silently so it doesn't try to render w/o defaults
      this.set("timeOptions", timeOptions, { silent: true });
      this.set(this.defaults); //set default attributes
      //reset dirty flag because the model is now clean
      this.dirty = false;
    },
    initializeCustom: function () {
      //initialize the time dropdown to be properly i18n'ed
      //loop through the minutes of the day in timeIncrement minute increments
      var timeIncrement = 60;
      var timeOptions = [];
      var minutesPerDay = 1440;
      var midnight = Moment({ minute: 0 });
      for (var minutes = 0; minutes < minutesPerDay; minutes += timeIncrement) {
        var time = Moment({ minute: 0 }).add(minutes, "minutes");
        var timeDisplay = Messenger.reqres.request("get:formatted:time", time);
        //time value is the millisecond offset from midnight to the timeString
        timeOptions.push({
          timeValue: time.valueOf() - midnight.valueOf(),
          timeString: timeDisplay,
        });
      }
      this.set("timeOptions", timeOptions, { silent: true });
    },
    save: function () {
      //Custom save method: Unset the timeOptions, which is used by Underscore
      //to populate the drop-down of scheduled time choices, before saving.
      //It isn't part of the model on the Java side and thus must be removed
      //before saving to avoid a bad request.
      //var timeOptions = this.get('timeOptions');
      this.unset("timeOptions");
      return this.constructor.__super__.save.apply(this, arguments);
      //Since the user might save by going to the topic page, re-open the topic, clear the statu,
      //and try to schedule a new one, we must make sure the time options stick around (that workflow
      //would not cause the model to be re-loaded and thus re-initialized).
      //Add silently so we don't trigger the dirty flag.
      //For some reason I haven't figured out, the below line will not fire.
      //I tried it with both Chrome and Firefox, and the line is being sent to and receive by the browser, but
      //not hit.  It's like when we super-apply, it gets skipped.
      //So I'll forget saving it here, and instead just re-build the time options later.
      //        this.set('timeOptions', timeOptions, {silent: true});
      //        console.log('why is the above line not being fired??!?!??!');
    },
  });

  return TopicScheduledStatusModel;
});
